import { Action } from '@ngrx/store';
import { Tag, Resource } from '@bidi/common-services';

export const ContentsLibraryActionTypes = {
    GET_TAGS: '[@bidi/common-components ContentsLibrary] GET_TAGS',
    GET_TAGS_SUCCESS: '[@bidi/common-components ContentsLibrary] GET_TAGS_SUCCESS',
    GET_TAGS_FAILURE: '[@bidi/common-components ContentsLibrary] GET_TAGS_FAILURE',
    GET_RESOURCES: '[@bidi/common-components ContentsLibrary] GET_RESOURCES',
    GET_RESOURCES_SUCCESS: '[@bidi/common-components ContentsLibrary] GET_RESOURCES_SUCCESS',
    GET_RESOURCES_FAILURE: '[@bidi/common-components ContentsLibrary] GET_RESOURCES_FAILURE',
    SELECTED_TAG : '[@bidi/common-components ContentsLibrary] SELECTED_TAG'
};

export class GetTags implements Action {
    readonly type = ContentsLibraryActionTypes.GET_TAGS;
  
    constructor (readonly payload: { type: string }) {
    }
}

export class GetTagsSuccess implements Action {
    readonly type = ContentsLibraryActionTypes.GET_TAGS_SUCCESS;
  
    constructor (readonly payload: Tag[] ) {
    }
}

export class GetTagsFailure implements Action {
    readonly type = ContentsLibraryActionTypes.GET_TAGS_FAILURE;
  
    constructor (readonly payload?: any) {
    }
}

export class GetResources implements Action {
    readonly type = ContentsLibraryActionTypes.GET_RESOURCES;
  
    constructor (readonly payload? : any) {
    }
}

export class GetResourcesSuccess implements Action {
    readonly type = ContentsLibraryActionTypes.GET_RESOURCES_SUCCESS;
  
    constructor (readonly payload:  Resource[] ) {
    }
}

export class GetResourcesFailure implements Action {
    readonly type = ContentsLibraryActionTypes.GET_RESOURCES_FAILURE;
  
    constructor (readonly payload?: any) {
    }
}

export class SelectedTag implements Action {
    readonly type = ContentsLibraryActionTypes.SELECTED_TAG;
  
    constructor (readonly payload: any) {
    }
}